import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import adapter from '../adapter';
export default function divFactory() {
  var _class;

  var _adapter$getRuntime = adapter.getRuntime(),
      PureComponent = _adapter$getRuntime.PureComponent,
      createElement = _adapter$getRuntime.createElement;

  return _class = /*#__PURE__*/function (_PureComponent) {
    _inheritsLoose(Div, _PureComponent);

    function Div() {
      return _PureComponent.apply(this, arguments) || this;
    }

    var _proto = Div.prototype;

    _proto.render = function render() {
      return createElement('div', this.props);
    };

    return Div;
  }(PureComponent), _class.displayName = 'Div', _class.version = '0.0.0', _class;
}